import React from 'react';

const CarouselCaption = ({children}) => {
    return (
        <div className='carousel-caption'>
            {children}
        </div>
    );
};

export default CarouselCaption;
